import { render, staticRenderFns } from "./TaskPageHeader.vue?vue&type=template&id=249d69d0"
import script from "./TaskPageHeader.vue?vue&type=script&lang=js"
export * from "./TaskPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports